import {Stack, Typography} from "@mui/material";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function ModalityListDisplay(props) {
  // const [mappings, setMappings] = useState(props.mappings);
  const [objList, setObjList] = useState(props.objList);
  const {defaultLanguage, mappings, topLabel} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!objList || objList.length === 0) return null;

  return (
    <div>
      <Typography variant="h4" noWrap className="section--title">{topLabel}</Typography>
      {objList.getObjList().map((item, index) => {
        // console.log(item);
        return (
          <Stack key={index} sx={{pt: 1}} spacing={1}>
            {!item.mediaType.isEmpty() && (
              <div>
                <Typography variant="body2" className={"key"}>
                  {getLabel(keys.msmediaType, "mediaType")}
                </Typography>
                {item.mediaType.getList().map((mediaTypeItem, index) => (
                  <div key={index}>
                    <Typography variant="body1">{getLabel(mediaTypeItem.getValue(), "")}</Typography>
                  </div>
                ))}
              </div>
            )}
          </Stack>
        );
      })}
    </div>
  );
}
